var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "awards" },
    [
      _c(
        "div",
        { staticClass: "grid" },
        _vm._l(_vm.computedObj, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "grid-item" },
            [_c("Award", { attrs: { item: item } })],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.hasLimit
        ? [
            _c(
              "div",
              { staticClass: "show-more" },
              [
                _c("HighlightButton", {
                  attrs: {
                    "button-type": "rounded",
                    "button-style": "outline",
                    "button-size": "small",
                    title: "Show More",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showMore()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }